import React from 'react';
import { getValueWithoutUnit } from '../../utils';

const NameCard = (props) => {
    const {
        id,
        name,
        coords,
        defaults: { typography, color, alignment },
    } = props;

    const specialTypo = typography === 'ThankYou';

    let newCoords;
    if (specialTypo) {
        const fontSizeWithoutUnit = getValueWithoutUnit(coords?.fontSize, 'px');
        const lineHeight = `${Number(fontSizeWithoutUnit) + 6}px`;

        newCoords = Object.assign({ lineHeight: lineHeight }, coords);
    } else {
        newCoords = coords;
    }

    const textAlignment = () => {
        switch (alignment) {
            case 'left':
                return 'text-left';
            case 'center':
                return 'text-center';
            case 'right':
                return 'text-right';
            default:
                return 'center';
        }
    };
    return (
        <div
            className={`draggable cursor-move w-37.5 rounded absolute p-1 top-3 left-3 z-10 border-dashed border-2 border-orange-500`}
            style={newCoords}
            draggable
            onDragStart={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                e.dataTransfer.setData('cardId', id);
                e.dataTransfer.setData('offsetX', e.clientX - rect.left);
                e.dataTransfer.setData('offsetY', e.clientY - rect.top);
                const el = e.currentTarget;
                setTimeout(() => {
                    el.style.visibility = 'hidden';
                }, 0);
            }}
            onDragEnd={(e) => {
                e.currentTarget.style.visibility = '';
            }}>
            <div className={`text-gray-900 drop-shadow-md ${textAlignment()} ${!specialTypo ? 'leading-5' : ''}`}>
                <span className="hidden lg:block absolute w-6 h-6 text-xs text-white -left-4 -top-4 bg-black/50 rounded-full p-1">
                    {id + 1}
                </span>
                <span className={`font_${typography} palette_${color}`}>{name}</span>
            </div>
        </div>
    );
};

export default NameCard;
